// extracted by mini-css-extract-plugin
export var columnList = "_bu-0";